import { layout } from '../../App.routing'

export const liveSportReplaysSegment = layout.component({
    type: 'lima',
    props: {
        verticalSpacing: 'xl',
        fontScale: 1.2,
        fixedRatios: ['16:9'],
        hasBackground: true,
        teaserMode: {
            initial: 'visible',
            xs: 'visible',
            sm: 'hidden',
            md: 'hidden',
        },
        initialColumns: 1,
        intermediateColumns: 2,
        finalColumns: 4,
        cardOrientation: { type: 'Landscape-Portrait' },
        dataDefinitionArgs: {
            type: 'listing',
            topics: [
                'sport/psa-footy',
                'sport/wafl',
                'sport/waflw',
                'sport/wafl-colts',
                'sport/swfl',
                'sport/field-hockey',
                'sport/basketball',
                'sport/netball',
                'sport/tennis',
            ],
            classification: { kind: 'editorial', label: 'replay' },
            includeSubTopics: false,
            paging: {
                page: 0,
                pageSize: 4,
            },
        },
        sectionHeader: {
            heading: 'Live Sport Replays',
            headingUrl: '/sport/live',
            section: 'sport',
        },
    },
})
